import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, FormGroup, Input, Button } from "reactstrap";
import { enqueueSnackbar } from "notistack";
import { uploadRegions } from "../../services/ValitanApiService";

const RegionsUploadModal = ({ isOpen, toggle, loadRegions, paginationInfo }) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
    };

    const handleFileUpload = async (event) => {
        event.preventDefault();

        if (!selectedFile) {
            enqueueSnackbar("No file selected.", { variant: 'error' });
            return; // Early return if no file is selected
        }

        try {
            // Create FormData object
            const formData = new FormData();
            formData.append('file', selectedFile); // Append the file to the FormData

            // Send FormData to the server
            const response = await uploadRegions(formData);
            if (response.data.status === 'success') {
                enqueueSnackbar(response.data.message, { variant: 'success' });
                loadRegions(paginationInfo.pageNumber, paginationInfo.pageSize); // Reload regions
                toggle(); // Close modal
            } else if (response.data.status === 'failed') {
                enqueueSnackbar(response.data.message, { variant: 'error' });
                loadRegions(paginationInfo.pageNumber, paginationInfo.pageSize); // Reload regions
                toggle(); // Close modal
            }

        } catch (error) {
            enqueueSnackbar("Something went wrong, try again", { variant: 'error' });
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop={"static"}>
            <ModalHeader toggle={toggle}>Upload Regions</ModalHeader>
            <ModalBody>
                <form onSubmit={handleFileUpload}>
                    <FormGroup>
                        <Input
                            type="file"
                            name="file"
                            id="fileUpload"
                            onChange={handleFileChange}
                            accept=".xlsx, .xls, .csv"
                        />
                    </FormGroup>
                    <Button type="submit" color="primary" className="float-end">
                        Upload
                    </Button>
                </form>
            </ModalBody>
        </Modal>
    );
};

export default RegionsUploadModal;
